import { getRouterBasename } from './routerBasename';

const DEFAULT_PATHS = {
  order: '/orders',
  leave: '/leave',
  visit: '/logs',
  fuel: '/fuel',
  critical: '/system-logs',
};

/** Parse notification meta JSON safely. */
export const parseNotificationMeta = (meta) => {
  if (!meta) return null;
  if (typeof meta === 'object') return meta;
  try {
    return JSON.parse(meta);
  } catch {
    return null;
  }
};

/** React-router path (no basename) for a notification row. */
export const getNotificationRoute = (notification) => {
  const meta = parseNotificationMeta(notification?.meta);
  const raw = meta?.url || DEFAULT_PATHS[notification?.type];
  if (!raw) return null;
  if (raw.startsWith('/admin/')) return raw.slice('/admin'.length) || '/';
  if (raw.startsWith('/qft/')) return raw.slice('/qft'.length) || '/';
  return raw;
};

/** Absolute browser URL for service worker / desktop notification clicks. */
export const getNotificationAbsoluteUrl = (notification) => {
  const route = getNotificationRoute(notification);
  if (!route) return null;
  const base = getRouterBasename();
  const path = `${base}${route.startsWith('/') ? route : `/${route}`}`;
  return `${window.location.origin}${path}`;
};

/** React-router path from an absolute notification URL (service worker messages). */
export const routeFromAbsoluteUrl = (absoluteUrl) => {
  if (!absoluteUrl) return null;
  try {
    const u = new URL(absoluteUrl, window.location.origin);
    const base = getRouterBasename();
    if (base && (u.pathname === base || u.pathname.startsWith(`${base}/`))) {
      const route = u.pathname.slice(base.length);
      return route.startsWith('/') ? route : `/${route}`;
    }
    return u.pathname || '/';
  } catch {
    return null;
  }
};
